import React, { useEffect, useState } from 'react'
import { Label } from '../../../../../components/ui/label';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '../../../../../components/ui/select';
import { components } from 'react-select';
import { useSelector } from 'react-redux';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../../../../../components/ui/dialog';
import Creatable from "react-select/creatable";
import { Button } from '../../../../../components/ui/button';

const AnalyticsModel = (props) => {
    const { show, onHide, saveData } = props;
    const {  analytics } = useSelector(state => state);
    const [error, setError] = useState({});
    const [formData, setFormData] = useState({
        sourceName: null,
        indicatorCategoryName: null,
        indicators: null,
        goals: null,
        targets: null,
        targetIndicators: null,
        series: null
    });

    useEffect(() => {
        if (show === false) {
            setFormData({
                sourceName: null,
                indicatorCategoryName: null,
                indicators: null,
                goals: null,
                targets: null,
                targetIndicators: null,
                series: null
            });
            setError({});
        }
    }, [show])





    const IndicatorSourceOptions = [{ value: 1, label: 'option 1' }, { value: 2, label: 'option 2' }]

    const indicatorSourceCategoryOptions = [{ value: 1, label: 'option 1' }, { value: 2, label: 'option 2' }]

    const indicatorGoals = [{ value: 1, label: 'option 1' }, { value: 2, label: 'option 2' }]

    const indicatorTargets =[{ value: 1, label: 'option 1' }, { value: 2, label: 'option 2' }]

    const indicatorOptions = [{ value: 1, label: 'option 1' }, { value: 2, label: 'option 2' }]

    const groupedIndicatorOptionsOptions = [
        {
            // label: 'World Bank:',
            options: indicatorOptions,
        },
    ];

    const groupStyles = {
        color: 'white',
        padding: '5px 5px',
        display: 'flex',
        fontWeight: '700',
        fontSize: '15px'
    };

    const indicatorSeparatorStyle = {
        alignSelf: 'stretch',
        marginBottom: 8,
        marginTop: 8,
        width: 1,
        cursor: 'pointer'
    };

    const IndicatorSeparator = ({
        innerProps,
    }) => {
        return <span style={indicatorSeparatorStyle} {...innerProps} />;
    };


    const GroupHeading = (props) => (
        <div style={groupStyles}>
            <components.GroupHeading {...props} />
        </div>
    );

    const targetIndicatorsOptions = [{ value: 1, label: 'option 1' }, { value: 2, label: 'option 1' }]


    const seriesOptions = [{ value: 1, label: 'option 1' }, { value: 2, label: 'option 1' }]

    const groupedOptions = [
        {
            label: 'World Bank:',
            // options: indicatorOptions,
        },
        {
            label: 'United Nations (SDGs):',
            // options: unitedNationsOptions,
        },
    ];
    const transformedData = analytics?.series?.flatMap((series) => {
        if (series.dimensions.length) {
            return series.dimensions.map((dimension) => {
                return {
                    label: `${series.description} / ${dimension.description}`,
                    value: dimension._id,
                    dimensionId: dimension._id,
                    seriesId: series._id,
                };
            });
        } else {
            return { value: series._id, label: series.description, seriesId: series._id, }
        }
    });


    return (
        <>
            <Dialog open={show} onOpenChange={onHide}>
                <DialogContent className="sm:max-w-[40%] gap-10">
                    <DialogHeader>
                        <DialogTitle className="text-center">{'Add Analytics'}</DialogTitle>
                    </DialogHeader>
                    <div className="dialog-body">
                        <div className="grid grid-cols-1 gap-5">
                            <div className="form-group">
                                <Label htmlFor="name" className="block mb-2.5 text-textV1 font-500">
                                    Select Indicator Source:<span style={{ color: 'red' }}>*</span>
                                </Label>
                                <Select
                                    defaultValue={IndicatorSourceOptions[0]}
                                >
                                    <SelectTrigger className="w-full">
                                        <SelectValue
                                            className='text-textV1'
                                            placeholder="Select Indicator Source"
                                        >
                                            {formData.sourceName !== null ? formData.sourceName?.label : "Select Indicator Source"}
                                        </SelectValue>
                                    </SelectTrigger>
                                    <SelectContent>
                                        <SelectGroup>
                                            {
                                                IndicatorSourceOptions && IndicatorSourceOptions.length > 0 ? IndicatorSourceOptions.map((item, index) => {
                                                    return <SelectItem key={index} className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2" value={JSON.stringify(item)}>{item?.label}</SelectItem>
                                                }) : <SelectItem disabled className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2 text-center" value={'No option'}>{'No option'}</SelectItem>
                                            }
                                        </SelectGroup>
                                    </SelectContent>
                                </Select>
                                <div className={error['sourceName'] ? "text-red text-[12px]" : ''}>{error['sourceName'] ? error['sourceName'] : null}</div>
                            </div>
                            {formData.sourceName?.label === "World Bank" &&
                                <>
                                    <div className="form-group">
                                        <Label htmlFor="name" className="block mb-2.5 text-textV1 font-500">
                                            Select Indicator Source Category:<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <Select
                                            disabled={formData.sourceName === null}
                                        >
                                            <SelectTrigger className="w-full">
                                                <SelectValue
                                                    className='text-textV1'
                                                    placeholder="Select Indicator Source"
                                                >
                                                    {formData.indicatorCategoryName !== null ? formData.indicatorCategoryName?.label : "Select Indicator Source"}
                                                </SelectValue>
                                            </SelectTrigger>
                                            <SelectContent>
                                                <SelectGroup>
                                                    {
                                                        indicatorSourceCategoryOptions && indicatorSourceCategoryOptions.length > 0 ? indicatorSourceCategoryOptions.map((item, index) => {
                                                            return <SelectItem key={index} className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2" value={JSON.stringify(item)}>{item?.label}</SelectItem>
                                                        }) : <SelectItem disabled className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2 text-center" value={'No option'}>{'No option'}</SelectItem>
                                                    }
                                                </SelectGroup>
                                            </SelectContent>
                                        </Select>
                                        <div className={error['indicatorCategoryName'] ? "text-red text-[12px]" : ''}>{error['indicatorCategoryName'] ? error['indicatorCategoryName'] : null}</div>
                                    </div>

                                    <div className={`form-group  ${formData.indicatorCategoryName === null ? 'cursor-not-allowed' : ''}`}>
                                        <Label htmlFor="name" className="block mb-2.5 text-textV1 font-500">
                                            Select Indicator:<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <Creatable
                                            className={`form-select rounded-sm  border-0  p-0`}
                                            classNamePrefix="select"
                                            placeholder='Select Indicator'
                                            name="All"
                                            value={formData.indicators}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            isDisabled={formData.indicatorCategoryName === null}
                                            onChange={null}
                                            options={groupedIndicatorOptionsOptions}
                                            components={{GroupHeading, IndicatorSeparator }}
                                            styles={{
                                                groupHeading: (base) => ({
                                                    color: 'black',
                                                }),
                                                menuList: (base) => ({
                                                    fontSize: '12px',
                                                    overflow: 'auto',
                                                    maxHeight: '260px'
                                                }),
                                                option: (base) => ({
                                                    ...base,
                                                    cursor: 'pointer',
                                                })

                                            }}
                                        />
                                        {/* <Creatable
                                            className={`form-select rounded-sm  border-0  p-0`}
                                            classNamePrefix="select"
                                            placeholder='Select Indicator'
                                            name="All"
                                            value={formData.indicators}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            isDisabled={formData.indicatorCategoryName === null}
                                            onChange={onChangeIndicatorOption}
                                            options={groupedIndicatorOptionsOptions}
                                            components={{ GroupHeading, IndicatorSeparator }}
                                            styles={{
                                                groupHeading: (base) => ({
                                                    color: 'black',
                                                }),
                                                menuList: (base) => ({
                                                    fontSize: '12px',
                                                    overflow: 'auto',
                                                    maxHeight: '260px'
                                                }),
                                                option: (base) => ({
                                                    ...base,
                                                    cursor: 'pointer',
                                                    width: '100%'
                                                }),
                                                // valueContainer: (base) => ({
                                                //     ...base,
                                                //     display: 'flex',
                                                //     flexWrap: 'nowrap',
                                                //     overflowX: 'auto',
                                                //     width: '100%'
                                                // })
                                            }}
                                        /> */}
                                        <div className={error['indicator'] ? "text-red text-[12px]" : ''}>{error['indicator'] ? error['indicator'] : null}</div>
                                    </div>
                                </>
                            }

                            {formData.sourceName?.label === "United Nations (SDGs)" &&
                                <>
                                    <div className="form-group">
                                        <Label htmlFor="name" className="block mb-2.5 text-textV1 font-500">
                                            Select Goals:<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <Select
                                            defaultValue={indicatorGoals[0]}
                                            disabled={formData.sourceName === null}
                                        >
                                            <SelectTrigger className="w-full">
                                                <SelectValue
                                                    className='text-textV1'
                                                    placeholder="Select Goals"
                                                >
                                                    {formData.goals !== null ? formData.goals?.label : "Select Goals"}
                                                </SelectValue>
                                            </SelectTrigger>
                                            <SelectContent>
                                                <SelectGroup>
                                                    {
                                                        indicatorGoals && indicatorGoals.length > 0 ? indicatorGoals.map((item, index) => {
                                                            return <SelectItem key={index} className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2" value={JSON.stringify(item)}>{item?.label}</SelectItem>
                                                        }) : <SelectItem disabled className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2 text-center" value={'No option'}>{'No option'}</SelectItem>
                                                    }
                                                </SelectGroup>
                                            </SelectContent>
                                        </Select>
                                        <div className={error['goals'] ? "text-red text-[12px]" : ''}>{error['goals'] ? error['goals'] : null}</div>
                                    </div>
                                    <div className="form-group">
                                        <Label htmlFor="name" className="block mb-2.5 text-textV1 font-500">
                                            Select Targets:<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <Select
                                            defaultValue={indicatorTargets[0]}
                                            disabled={formData.goals === null}
                                        >
                                            <SelectTrigger className="w-full">
                                                <SelectValue
                                                    className='text-textV1'
                                                    placeholder="Select Target"
                                                >
                                                    {formData.targets !== null ? formData.targets?.label : "Select Target"}
                                                </SelectValue>
                                            </SelectTrigger>
                                            <SelectContent>
                                                <SelectGroup>
                                                    {
                                                        indicatorTargets && indicatorTargets.length > 0 ? indicatorTargets.map((item, index) => {
                                                            return <SelectItem key={index} className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2" value={JSON.stringify(item)}>{item?.label}</SelectItem>
                                                        }) : <SelectItem disabled className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2 text-center" value={'No option'}>{'No option'}</SelectItem>
                                                    }
                                                </SelectGroup>
                                            </SelectContent>
                                        </Select>
                                        <div className={error['targets'] ? "text-red text-[12px]" : ''}>{error['targets'] ? error['targets'] : null}</div>
                                    </div>
                                    <div className="form-group">
                                        <Label htmlFor="name" className="block mb-2.5 text-textV1 font-500">
                                            Select Indicator:<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <Select
                                            defaultValue={indicatorTargets[0]}
                                            disabled={formData.targets === null}
                                        >
                                            <SelectTrigger className="w-full">
                                                <SelectValue
                                                    className='text-textV1'
                                                    placeholder="Select Indicator"
                                                >
                                                    {formData.targetIndicators !== null ? formData.targetIndicators?.label : "Select Indicator"}
                                                </SelectValue>
                                            </SelectTrigger>
                                            <SelectContent>
                                                <SelectGroup>
                                                    {
                                                        targetIndicatorsOptions && targetIndicatorsOptions.length > 0 ? targetIndicatorsOptions.map((item, index) => {
                                                            return <SelectItem key={index} className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2" value={JSON.stringify(item)}>{item?.label}</SelectItem>
                                                        }) : <SelectItem disabled className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2 text-center" value={'No option'}>{'No option'}</SelectItem>
                                                    }
                                                </SelectGroup>
                                            </SelectContent>
                                        </Select>
                                        <div className={error['targetIndicators'] ? "text-red text-[12px]" : ''}>{error['targetIndicators'] ? error['targetIndicators'] : null}</div>
                                    </div>
                                    <div className={`form-group  ${formData.targetIndicators === null ? 'cursor-not-allowed' : ''}`}>
                                        <Label htmlFor="name" className="block mb-2.5 text-textV1 font-500">
                                            Select Series:<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <Creatable
                                            className={`form-select rounded-sm  border-0  p-0`}
                                            classNamePrefix="select"
                                            placeholder='Select Series'
                                            name="All"
                                            value={formData.series}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            isDisabled={formData.targetIndicators === null}
                                            onChange={null}
                                            options={transformedData}
                                            components={{ GroupHeading, IndicatorSeparator }}
                                            styles={{
                                                groupHeading: (base) => ({
                                                    color: 'black',
                                                }),
                                                menuList: (base) => ({
                                                    fontSize: '12px',
                                                    overflow: 'auto',
                                                    maxHeight: '260px',
                                                }),
                                                option: (base) => ({
                                                    ...base,
                                                    cursor: 'pointer',
                                                })

                                            }}
                                        />
                                        <div className={error['series'] ? "text-red text-[12px]" : ''}>{error['series'] ? error['series'] : null}</div>
                                    </div>
                                </>}
                        </div>
                    </div>
                    <DialogFooter className={"!justify-end !gap-2"}>
                        <Button type="submit" size="sm" className="min-w-[100px]" onClick={null}>Save</Button>
                        <Button type="submit" size="sm" className="min-w-[100px]" variant={"outline"} onClick={props.onHide}>Cancel</Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default AnalyticsModel